import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCities as getCitiesService,
  getDistricts as getDistrictsService,
  getNeighbourhoods as getNeighbourhoodsService,
} from "./location.service";
import {
  CitiesResponse,
  DistrictsResponse,
  NeighbourhoodsResponse,
  GetCitiesRequest,
  GetDistrictsRequest,
  GetNeighbourhoodsRequest,
} from "./location.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getCities = createAsyncThunk<
  CitiesResponse,
  GetCitiesRequest | undefined,
  { rejectValue: string }
>("location/getCities", async (params, { rejectWithValue }) => {
  try {
    const response = await getCitiesService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getDistricts = createAsyncThunk<
  DistrictsResponse,
  GetDistrictsRequest,
  { rejectValue: string }
>("location/getDistricts", async (params, { rejectWithValue }) => {
  try {
    const response = await getDistrictsService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getNeighbourhoods = createAsyncThunk<
  NeighbourhoodsResponse,
  GetNeighbourhoodsRequest,
  { rejectValue: string }
>("location/getNeighbourhoods", async (params, { rejectWithValue }) => {
  try {
    const response = await getNeighbourhoodsService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
